import { safeLocalStorage } from './storage-utils';

interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export const sessionCache = {
  set: <T>(key: string, data: T) => {
    try {
      const entry: CacheEntry<T> = {
        data,
        timestamp: Date.now(),
      };
      safeLocalStorage.setItem(key, JSON.stringify(entry));
    } catch (err) {
      console.warn(`[Cache] Set failed for key "${key}":`, err);
    }
  },

  get: <T>(key: string): T | null => {
    try {
      const stored = safeLocalStorage.getItem(key);
      if (!stored) return null;

      const entry: CacheEntry<T> = JSON.parse(stored);
      const now = Date.now();

      if (now - entry.timestamp > CACHE_TTL) {
        safeLocalStorage.removeItem(key);
        return null;
      }

      return entry.data;
    } catch (err) {
      console.warn(`[Cache] Get failed for key "${key}":`, err);
      return null;
    }
  },

  remove: (key: string) => {
    safeLocalStorage.removeItem(key);
  },
};
